import React from 'react';
import Select, {Props} from 'react-select';

export function PortalSelectOption({value}: {
  value: number|boolean|string,
  children: any
}) {
  return null;
}

export function PortalSelect({value, onChange, children, ...props}: {
  value: any,
  onChange: (value: any) => void,
  props: Props
  children: any
}) {

  let selected = null;

  const options = React.Children.map(children, el => {
    if (!el.props) {
      return null;
    }
    const obj = {
      label: el.props.children,
      value: el.props.value
    };
    if (el.props.value === value || (typeof value === 'number' && value.toString() === el.props.value)) { //loosely check if the integer version matches not sure where else to put this check to handle storing values as integers but have globalListConstraint
      selected = obj;
    }
    return obj;
  });



  return <Select
        {...props}
        aria-label="Select"
        styles={customStyles}
        title="Select"
        openMenuOnFocus
        placeholder={null}
        options={options}
        value={selected}
        onChange={(val) => onChange(val.value)}
        components={{
          IndicatorSeparator: () => null,
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          zIndex: 3,
          colors: {
            ...theme.colors,
            primary25: 'rgb(0, 115, 157, 0.1)',
            primary: 'rgba(0, 115, 157, 0.5)',
            neutral30: 'rgba(0, 115, 157, 0.5)',
          },
        })}
      />
}

const customStyles = {
  control: (base) => ({
    ...base,
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};